import fetch from "isomorphic-fetch";
import _ from "lodash";

const serviceHost = process.env.REACT_APP_SERVICE;
// const emailSubject = "LP web – Complimentary preview trip offer";
// const to = ['mondit.thum@gmail.com', 'napat@forviz.co.th ']
// const cc = ['hlex.pon@gmail.com']
// const to = [
//   "Sherry.Jia@banyantree.com",
//   "sinniont@lagunaproperty.com",
//   "stefanoc@lagunaphuket.com"
// ];
// const cc = ["info@lagunaproperty.com"];

const sendEmailOnlyService = ({
  subject,
  to,
  cc,
  reCaptchaToken,
  data
}) => {
  return fetch(`${serviceHost}/email/send`, {
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    body: JSON.stringify({
      "g-recaptcha-response": reCaptchaToken,
      data,
      emailSetting: {
        subject,
        to: _.join(to, ","),
        cc: _.join(cc, ",")
      }
    })
  });
};

export { sendEmailOnlyService }



// WEBPACK FOOTER //
// ./src/services/email.js